var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophoneConnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10V10.8333C18 14.5152 14.866 17.5 11 17.5C7.13401 17.5 4 14.5152 4 10.8333V10M11 14.1667C9.067 14.1667 7.5 12.6743 7.5 10.8333V5.83333C7.5 3.99238 9.067 2.5 11 2.5C12.933 2.5 14.5 3.99238 14.5 5.83333V10.8333C14.5 12.6743 12.933 14.1667 11 14.1667Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneConnected);
export default __webpack_public_path__ + "static/media/microphone-connected.5163c5ef1cc30995481d74788c4bb191.svg";
export { ForwardRef as ReactComponent };